import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ArtifactStatus, IKBCatalog, IKBCatalogCategory } from '../interfaces/IBase-knowledge-catalog';
import { I18nService } from 'i18n/i18n.service';
import { KBCatalogFactory } from '../factories/kb-catalog.factory';
import { CatalogOperationsService } from '../services/catalog-operations.service';
import { ModalOperationsService } from '../services/modal-operations.service';
import { NotificationService } from '../services/notification.service';
import { StateOperationsService } from '../services/state-operations.service';
import { update } from 'lodash';

@Component({
  selector: 'biz-base-knowledge-catalog-static',
  templateUrl: './base-knowledge-catalog-static.component.html',
  styleUrls: ['./base-knowledge-catalog-static.component.scss']
})
export class BaseKnowledgeCatalogStaticComponent implements OnChanges {

  public allCategory: IKBCatalogCategory = { DisplayName: 'All', Description: 'All', Id: 'All', Expanded: false, EditMode: false, KBCatalogs: [] };
  public categoryList: IKBCatalogCategory[] = [];
  public selectedCategory: IKBCatalogCategory;
  public Processing = ArtifactStatus.Processing;
  public Available = ArtifactStatus.Available;
  public Failed = ArtifactStatus.Failed;
  public ToProcess = ArtifactStatus.ToProcess;
  public Unknown = ArtifactStatus.Unknown;
  public showEditedCategory: boolean = false;

  @Input() filteredCategoryList: IKBCatalogCategory[] = [];
  @Output() reloadCatalogs = new EventEmitter<boolean>();

  constructor(
    private _i18nService: I18nService,
    private _catalogOperationsService: CatalogOperationsService,
    private _modalOperationsService: ModalOperationsService,
    private _notificationService: NotificationService,
    private _stateOperationsService: StateOperationsService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit(): void {
  }

  addNewCatalog(category: IKBCatalogCategory, event?: Event) {
    this._stateOperationsService.stopPropagation(event);
    this.openCatalogModal(KBCatalogFactory.createNew(category), category);
  }

  editCatalog(catalog: IKBCatalog, category: IKBCatalogCategory) {
    this.openCatalogModal(catalog, category);
  }

  addArtificat(catalog?: IKBCatalog) {
    this._modalOperationsService.openArtifactModal(catalog).subscribe(result => {
      if (result) {
        // Handle artifact creation logic here
      }
    });
  }

  openCatalogModal(catalog?: IKBCatalog, category?: IKBCatalogCategory): void {
    this._modalOperationsService.openArtifactModal(catalog).subscribe(result => {
      if (result) {
        this.validateAndSaveCatalog(result);
      }
    });
  }

  deleteCatalog(catalog: IKBCatalog) {
    this._modalOperationsService.openDeleteConfirmationModal(catalog).subscribe((result) => {
      if (result === 'delete') {
        this.deleteCatalogService(catalog);
      }
    });
  }

  deleteCatalogService(catalog: IKBCatalog) {
    this._catalogOperationsService.deleteCatalog(catalog).subscribe({
      next: (response) => {
        this.reloadCatalogs.emit(true);
        this._notificationService.showSuccess(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'));
      }
    });
  }

  validateAndSaveCatalog(catalog: IKBCatalog): void {
    this.updateCatalogInFilteredList(catalog);
    this._catalogOperationsService.validateAndSaveCatalog(catalog).subscribe({
      next: (response) => {
        this.reloadCatalogs.emit(true);
        this._notificationService.showSuccess(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'));
      },
      error: (error) => {
        if (error.type === 'duplicate_name') {
          this._notificationService.showError(this._i18nService.instant('BASEKNOWLEDGECATALOG.ERROR_NAME_DUPLICATE'));
        } else {
          this._notificationService.showError(this._i18nService.instant('GLOBAL.AN_ERROR_HAS_OCCURRED'));
        }
      }
    });
  }

  private updateCatalogInFilteredList(updatedCatalog: IKBCatalog): void {
    for (const category of this.filteredCategoryList) {
      const catalogIndex = category.KBCatalogs.findIndex(catalog => catalog.Id === updatedCatalog.Id);
      if (catalogIndex !== -1) {
        updatedCatalog.Expanded = true;
        category.KBCatalogs[catalogIndex] = { ...updatedCatalog, Expanded: true };    
        break;
      }
    }
  }

  toggleCategory(category: IKBCatalogCategory): void {
    this._stateOperationsService.toggleCategory(category);
  }

  toggleCatalog(catalog: IKBCatalog): void {
    this._stateOperationsService.toggleCatalog(catalog);
  }

  onToggleSelectAll(status: string, event?: Event) {
    this._stateOperationsService.handleToggleSelectAll(status, event);
  }

  getSortedCatalogs(category: any): any[] {
    return category.KBCatalogs ? [...category.KBCatalogs].sort((a: any, b: any) => 
      a.DisplayName.localeCompare(b.DisplayName)
    ) : [];
  }

  get isDevelopment(): boolean {
    const environmentType = sessionStorage.getItem('environmentType');
    return environmentType?.toLowerCase() === 'development';
  } 
}
